import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import { ConversationTypeRecord } from '../../../../../store/one-query/conversationType';
interface PropsType {
    show: boolean;
    handleClose: () => void;
    PersonaData:ConversationTypeRecord;
}
const PersonaDetails = ({show,handleClose,PersonaData}:PropsType) => {
    return (
        <Modal
        className="personaModal"
        show={show}
        size="lg"
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="mb-0">Persona</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="personDesLabel" htmlFor="personaName">
            Name
          </label>
          <div
            className={`inputPersonaName w-100`}
          >
            <Form.Control
              className="w-100"
              id="personaName"
              name="title"
              value={PersonaData?.title}
              readOnly
              style={{border:"none"}}
            />
          </div>
          <label className="personDesLabel" htmlFor="personaDes">
            Description
          </label>
          <div className="desContainer">
            <div
              className={`inputPersonaDescription d-flex flex-column w-100`}
            >
              <Form.Control
                id="personaDes"
                value={PersonaData?.description}
                name="description"
                readOnly
                style={{border:"none"}}
              />
              <textarea
                className="w-100"
                value={PersonaData?.objective ||""}
                name="objective"
                readOnly
                style={{border:"none"}}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
}

export default PersonaDetails;